
export class GroupEntity {

    public static fromDto(dto: any): GroupEntity {
        if (!dto) {
            return new GroupEntity();
        }
        const entity = new GroupEntity();
        entity.id = dto.id;
        entity.eventId = dto.eventId;
        entity.name = dto.name;
        entity.concurrency = dto.concurrency;

        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): GroupEntity[] {
        const entities: GroupEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = GroupEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: GroupEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }
    public id: string = null;
    public eventId: string = null;
    public name: string = null;
    public concurrency: string = null;

    public toDto(): any {
        return {
            id: this.id,
            eventId: this.eventId,
            name: this.name,
            concurrency: this.concurrency
        };
    }
}
